module.exports = __webpack_public_path__ + "img/diw_16_LowStock.ad1effbf.png";